var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScrollUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.17 4.335.756 13.75a2.586 2.586 0 0 0 0 3.662 2.586 2.586 0 0 0 3.661 0l7.581-7.586 7.58 7.586a2.586 2.586 0 0 0 3.662 0 2.586 2.586 0 0 0 0-3.662l-9.414-9.414a2.59 2.59 0 0 0-3.656 0"
})));
export default SvgScrollUp;